import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import GlobalNav from '../GlobalNav';
import HomeProdLifecycle from './HomeProdLifecycle';
import HomeCopilot from './HomeCopilot';
import HomeTextractor from './HomeTextractor';
import HomeGenBI from './HomeGenBI';
import HomeSLR from './HomeSLR';
import HomeFabrics from './HomeFabrics';
import Footer from '../Footer';
import '../../../styles/homepagecss/Home.css';

const Home = () => {
  const [scrollY, setScrollY] = useState(0);
  const [activeTab, setActiveTab] = useState('genbi');

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    
    // Handle hash-based navigation
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash === '#home-copilot-detail') setActiveTab('copilot');
      else if (hash === '#textractor-detail') setActiveTab('textractor');
      else if (hash === '#genbi-detail') setActiveTab('genbi');
      else if (hash === '#slr-detail') setActiveTab('slr');
    };

    // Initial check for hash
    handleHashChange();
    
    // Listen for hash changes
    window.addEventListener('hashchange', handleHashChange);
    
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('hashchange', handleHashChange);
    };
  }, []);

  // Function to handle tab switching
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.location.hash = tab + '-detail';
  };

  return (
      <div className="vh-100 background-color2 overflow-y-hidden">
        <div className="container margin-bottom-1 ">
           <GlobalNav/>
        </div>

        <div className="scrollable-element vh-90">
        {/* ev-home */}
        <section className="ev-home-section-evaior">
          <div className="container">
            <p className="ev-home-main-title ev-light-reg text-center m-auto col-9 margin-top-5 margin-bottom-5">
              Turn Data Chaos into Business Decisions with <span className="gradient-font8-animated">Enterprise AI Ecosystem</span>
            </p>
                  
            <div className="row">
              <div className="col-lg-5 col-md-5 col-12 mb-3">
                <div className="row g-3">
                    <div className="col-6">
                      <div className="gradient-font7 ev-bold-reg ev-fs-35">90x</div>
                      <div className="ev-reg-p-dark ev-fs-13 ev-reg"><span className="ev-bold-med">Faster.</span> Evaior turns months of manual analysis into minutes of intelligent automation.</div>
                    </div>
                    <div className="col-6">
                      <div className="gradient-font7  ev-bold-reg ev-fs-35">20+</div>
                      <div className="ev-reg-p-dark ev-fs-13 ev-reg"><span className="ev-bold-med">Supported languages.</span> From data to analytics and multilingual reports all in one place.</div>
                    </div>
                    <div className="col-6">
                      <div className="gradient-font7  ev-bold-reg ev-fs-35">100%</div>
                      <div className="ev-reg-p-dark ev-fs-13 ev-reg"><span className="ev-bold-med">Audit ready.</span> Every answer is cited, every insight traceable, every decision defensible. </div>
                    </div>
                    <div className="col-6">
                      <div className="gradient-font7  ev-bold-reg ev-fs-35">1000+</div>
                      <div className="ev-reg-p-dark ev-fs-13 ev-reg"><span className="ev-bold-med">Ingested documents</span>  analyzed within seconds, orchestrating AI workflows that adapt to your business.</div>
                    </div>                    
                </div>
              </div>

              <div className="col-lg-7 col-md-7 col-12">
                <div className="row g-3 mb-3">
  
                  <div className="col-lg-4 col-md-4 col-6 d-flex">
                    <div className="ev-home-main-feature-card ev-card-11 w-100">
                      <p className="ev-reg-p-dark ev-fs-15 d-flex">GenBI: AI Analytics & Reports</p>
                      <div className="ev-home-main-feature-card-default text-end">
                        <span className="ev-reg-p-blue ev-fs-30 me-2"><i className="bi bi-plus-circle-dotted"></i></span>
                      </div>
                      <div className="ev-home-main-feature-card-hidden me-3 ev-small-p-dark ev-reg">
                        <div>
                        <ul className="mb-3">
                          <li>Dynamic Templates</li>
                          <li>Multimodal AI agents</li>
                          <li>Exportable with version control</li>
                        </ul>
                          <a href="#genbi-detail" className="ev-btn-white-fill-round ev-btn-small ev-bold-reg ms-3" onClick={() => handleTabChange('genbi')}>
                            Learn More &nbsp; <i className="bi bi-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                   <div className="col-lg-4 col-md-4 col-6 d-flex">
                    <div className="ev-home-main-feature-card ev-card-11 w-100">
                      <p className="ev-reg-p-dark ev-fs-15 d-flex">Genie.ai: Data Intelligence</p>
                      <div className="ev-home-main-feature-card-default text-end">
                        <span className="ev-reg-p-blue ev-fs-30 me-2"><i className="bi bi-plus-circle-dotted"></i></span>
                      </div>
                      <div className="ev-home-main-feature-card-hidden me-3 ev-small-p-dark ev-reg">
                        <div>
                        <ul className="mb-3">
                          <li>Chat with Your Data</li>
                          <li>Traceable, No Hallucinations</li>
                          <li>Multimodal Responses</li>
                        </ul>
                          <a href="#copilot-detail" className="ev-btn-white-fill-round ev-btn-small ev-bold-reg ms-3" onClick={() => handleTabChange('copilot')}>
                            Learn More &nbsp; <i className="bi bi-arrow-right"></i>
                         </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div className="col-lg-4 col-md-4 col-6 d-flex">
                    <div className="ev-home-main-feature-card ev-card-11 w-100">
                      <p className="ev-reg-p-dark ev-fs-15 d-flex">SLR AI Toolkit: PRISMA-compliant</p>
                      <div className="ev-home-main-feature-card-default text-end">
                        <span className="ev-reg-p-blue ev-fs-30 me-2"><i className="bi bi-plus-circle-dotted"></i></span>
                      </div>
                      <div className="ev-home-main-feature-card-hidden me-3 ev-small-p-dark ev-reg">
                        <div>
                        <ul className="mb-3">
                          <li>2-phase automated literature review</li>
                          <li>AI & human review processes with conflict resolution</li>
                        </ul>
                          <a href="#slr-detail" className="ev-btn-white-fill-round ev-btn-small ev-bold-reg ms-3" onClick={() => handleTabChange('slr')}>
                            Learn More &nbsp; <i className="bi bi-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4 col-md-4 col-6 d-flex">
                    <div className="ev-home-main-feature-card ev-card-7 w-100">
                      <p className="ev-reg-p-dark ev-fs-15 d-flex">Textractor: Grid Extraction</p>
                      <div className="ev-home-main-feature-card-default text-end">
                        <span className="ev-reg-p-blue ev-fs-30 me-2"><i className="bi bi-plus-circle-dotted"></i></span>
                      </div>
                      <div className="ev-home-main-feature-card-hidden me-3 ev-small-p-dark ev-reg">
                        <div>
                        <ul className="mb-3">
                          <li>AI-powered data extraction</li>
                          <li>Exportable for downstream analytics</li>
                        </ul>
                          <a href="#textractor-detail" className="ev-btn-white-fill-round ev-btn-small ev-bold-reg ms-3" onClick={() => handleTabChange('textractor')}>
                            Learn More &nbsp; <i className="bi bi-arrow-right"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>



                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Lifecycle Section */}
        <section className="background-color2">
          <div className="container py-5">
            <HomeProdLifecycle/>
          </div>
        </section>
        
        {/* Fabric Section with Tools */}
        <HomeFabrics />

        {/* Feature Tabs Navigation Section */}
        <section className="background-color2 margin-top-4" id="feature-tabs">
            {/* Tab Navigation */}
            <div className="feature-tabs-navigation container">
              <ul>
                <li 
                  className={activeTab === 'genbi' ? 'active' : ''}
                  onClick={() => handleTabChange('genbi')}
                >
                  <span>GenBI</span>
                </li>
                <li 
                  className={activeTab === 'copilot' ? 'active' : ''}
                  onClick={() => handleTabChange('copilot')}
                >
                  <span>Genie.ai</span>
                </li>
                <li 
                  className={activeTab === 'slr' ? 'active' : ''}
                  onClick={() => handleTabChange('slr')}
                >
                  <span>SLR</span>
                </li>
                <li 
                  className={activeTab === 'textractor' ? 'active' : ''}
                  onClick={() => handleTabChange('textractor')}
                >
                  <span>Textractor</span>
                </li>
              </ul>
            </div>

            {/* Tab Content */}
            <div className="feature-tabs-content">
              <div id="genbi-detail" className={`feature-tab-pane ${activeTab === 'genbi' ? 'active' : ''}`}>
               <HomeGenBI />
              </div>
              <div id="copilot-detail" className={`feature-tab-pane ${activeTab === 'copilot' ? 'active' : ''}`}>
                <HomeCopilot />
              </div>
              <div id="slr-detail" className={`feature-tab-pane ${activeTab === 'slr' ? 'active' : ''}`}>
               <HomeSLR />
              </div>
              <div id="textractor-detail" className={`feature-tab-pane ${activeTab === 'textractor' ? 'active' : ''}`}>
               <HomeTextractor />
              </div>
            </div>

          <div className="background-color1"> 
            <div className="container margin-top-4 py-5">
              <div className="margin-bottom-3 ev-small-p-dark ev-bold-reg ev-fs-25">
                Your Data Has Stories to Tell. <br/>Evaior Helps You Listen.
              </div>
              <div className="row g-4">
                <div className="col-lg-4 col-md-5 col-12 d-flex">
                  <div className="ev-card-3 ev-padding-xlarge">
                    <h3 className="ev-bold-med ev-fs-20 ev-reg-p-blue mb-3 mt-3">
                      Ready to Turn Data into Intelligence?
                    </h3>
                    <p className="ev-reg-p-dark ev-fs-15 margin-bottom-10">
                      Find the plan that matches your needs. Start building your data fabric today.
                    </p>
                    <a href="#" className="ev-btn-blue-fill-round ev-btn-med ev-bold-reg">
                      Explore Plans <i className="bi bi-arrow-right ms-2"></i>
                    </a>
                  </div>
                </div>
                
                <div className="col-lg-8 col-md-7 col-12">
                  <div className="ev-plans-image-wrap">
                    <img 
                      src="/media/img4.jpg" 
                      alt="Evaior Platform" 
                      className="w-100"
                    />
                    <div className="ev-plans-caption">
                      <h4 className="ev-bold-med mb-3">One Platform. Endless Possibilities.</h4>
                      <p className="ev-reg">Build your intelligence architecture. Let AI do what it does best — analyze, extract, synthesize, and generate insights at scale. </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Footer/> 
        </div>
      </div>
  );
};

export default Home;